export default __webpack_public_path__ + "static/media/print.12179adb.svg";